/**
 * Identificador de correlación de una petición (EP-02 — base operativa).
 *
 * El backend lo acepta en `X-Correlation-Id`, lo imprime en cada línea de log de la petición y
 * lo devuelve dentro de `details.correlationId` en cualquier respuesta de error. Generándolo
 * aquí, una acción que falla en el móvil o en la web se puede seguir hasta el log del backend
 * con el identificador que ya tiene el cliente, sin depender de que la respuesta llegue.
 */
export const CORRELATION_ID_HEADER = 'X-Correlation-Id'

/**
 * Genera un identificador nuevo para una petición.
 *
 * Usa `crypto.randomUUID` cuando está disponible (navegadores actuales y WebView de Capacitor) y
 * cae en un identificador aleatorio equivalente cuando no lo está: sirve para correlacionar, no
 * para autenticar, así que no necesita garantías criptográficas.
 */
export const newCorrelationId = (): string => {
  const webCrypto = globalThis.crypto
  if (webCrypto && typeof webCrypto.randomUUID === 'function') {
    return webCrypto.randomUUID()
  }
  const random = () => Math.random().toString(16).slice(2, 10)
  return `${random()}-${random()}-${random()}-${random()}`
}
